import { TestSereisRouteURL, AppRouteURL, AppRouteURLwithChilds } from '@Constants/app-route-url.constant';
import { Link, useNavigate } from 'react-router-dom';
import './MockTestSeries.scss';
import { useAppSelector } from "@Src/app/hooks";
import { Card } from 'primereact/card';
import SvgIcon from '@Components/icons/SvgIcon';
import { NoSubscriptionDialog } from '@Components/NoSubscriptionDialog/NoSubscriptionDialog';
import { useSubscriptionNavigation } from '@Src/hooks/useSubscriptionNavigation';
import { Dialog } from 'primereact/dialog';

export const MockTestSeries = ({ mockTestSeriesList, onLoadMore, hasMore, loading }: any) => {

    const loginData = useAppSelector((state: any) => state.login);
    const isLoggedIn = loginData?.isLoggedIn;
    const { checkSubscriptionAndNavigate, subscriptionDialogProps, pendingTestDialogProps } = useSubscriptionNavigation();

    const isDiagnosticPage = window.location.pathname.includes(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES);
    const seriesRouteURL = isDiagnosticPage ? AppRouteURL.DIAGNOSTIC_MOCKTEST_SERIES : AppRouteURL.MOCKTEST_SERIES;

    return (
        <>
            <section className="most-popular-series-container ia-container px-2">
                <div className="mock-test-listing-header">
                    Practice Test
                </div>

                <div className="most-popular-cards-container p-0" style={{ flex: 'none', display: 'block' }}>
                    {
                        mockTestSeriesList && mockTestSeriesList.length > 0 ? (
                            mockTestSeriesList.map((element: any) => {
                                return (
                                    <Card key={element.testSeriesId || element.Id} className='custome-card ia-testlist ia-testseries-all-card mb-5'>
                                        <div className='grid m-0 h-full'>
                                            <div className='col-12 lg:col-3 p-0 tw-relative'>
                                                <div className="ia-testlist-image">
                                                    <img
                                                        src={element.testSeriesImage || element.Image || "/noimage.png"}
                                                        alt={element.testSeriesName || element.Name}
                                                        onError={(e: any) => { e.target.src = "/noimage.png" }}
                                                        className="tw-w-full tw-h-full tw-object-cover tw-rounded-l-2xl"
                                                        style={{ minHeight: '140px' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-12 lg:col-9'>
                                                <div className='ia-testlist-header tw-flex tw-justify-between tw-items-start tw-gap-3 px-2 pt-2'>
                                                    <div className='tw-flex-1'>
                                                        <div className='tw-flex tw-items-center tw-gap-1'>
                                                            <h2 className='tw-font-bold tw-text-xl lg:tw-text-2xl tw-inline tw-line-clamp-2'>{element.testSeriesName || element.Name}</h2>
                                                            <span className='badge-difficulty-level tw-ml-2 tw-inline-flex tw-align-middle'>Level {element.difficultyLevel || 1}</span>
                                                        </div>

                                                        <div dangerouslySetInnerHTML={{ __html: element.Description }} className='tw-mt-2 mb-2 test-description'></div>
                                                    </div>

                                                    <div className='tw-flex-shrink-0'>
                                                        <button
                                                            className='ia-btn ia-btn-primary py-2 px-6'
                                                            onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${seriesRouteURL}/${element.testSeriesId || element.Id}`)}
                                                        >
                                                            <span className='tw-text-lg'>Take a Test</span>
                                                        </button>
                                                    </div>
                                                </div>


                                                {/* Card SubHeader */}
                                                <div className='ia-testlist-subheader pb-2'>
                                                    <div className='grid mt-2 px-2 align-items-center'>
                                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                                            <SvgIcon name="question" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                            <span style={{ paddingLeft: '8px' }}>{element.Questions || element.NoOfQuestion || 0} Questions</span>
                                                        </div>

                                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                                            <SvgIcon name="time" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                            <span style={{ paddingLeft: '8px' }}>{(element.Time || element.Duration || 0) / 60} mins</span>
                                                        </div>

                                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                                            <SvgIcon name="userMaster" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                            <span style={{ paddingLeft: '8px' }}>{element.NoOfStudent && typeof element.NoOfStudent === 'object' && element.NoOfStudent.data ? element.NoOfStudent.data[0] : (element.NoOfStudent || '0')} Attempts</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                )
                            })
                        ) : (
                            <div className="no-data-section text-center p-5">
                                <div className="no-data-message" style={{ color: '#667085', fontSize: '1.25rem' }}>
                                    No <span style={{ fontWeight: 600, color: '#7f56d9' }}>Mock Test Series</span> found!
                                </div>
                            </div>
                        )
                    }
                </div>

                {hasMore && (
                    <div className="lode-more-card">
                        <button
                            className="ia-btn ia-btn-primary py-2 px-6"
                            onClick={onLoadMore}
                            disabled={loading}
                        >
                            <span className='tw-text-lg'>
                                {loading ? 'Loading...' : 'Load More'}
                            </span>
                        </button>
                    </div>
                )}
            </section>

            <NoSubscriptionDialog
                {...subscriptionDialogProps}
            />
            <Dialog
                visible={pendingTestDialogProps.visible}
                onHide={pendingTestDialogProps.onHide}
                header="Pending Test"
                style={{ width: '420px' }}
                modal
                draggable={false}
                resizable={false}
                closable={true}
            >
                <div className="tw-text-center tw-py-2">
                    <p className="tw-text-base tw-mb-1">You have a pending test:</p>
                    <p className="tw-font-semibold tw-text-lg tw-mb-4" style={{ color: 'var(--ia-primary)' }}>
                        {pendingTestDialogProps.pendingTest?.TestSeriesName}
                    </p>
                    <p className="tw-text-sm tw-text-gray-500 tw-mb-6">
                        Please complete your pending test before starting a new one. For more details, check your test activity on My Test.
                    </p>
                    <div className="tw-flex tw-justify-center">
                        <button
                            className="ia-btn ia-btn-primary py-2 px-5"
                            onClick={pendingTestDialogProps.onContinue}
                        >
                            Go To My Test
                        </button>
                    </div>
                </div>
            </Dialog>
        </>
    )
}